module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('nav', {
    staticClass: "navbar navbar-default navbar-static-top"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _c('div', {
    staticClass: "navbar-collapse collapse",
    attrs: {
      "id": "navbar"
    }
  }, [_c('ul', {
    staticClass: "nav navbar-nav nav-pills"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "home"
    }
  }, [_vm._v("Home")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "about"
    }
  }, [_vm._v("About")])], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar-header"
  }, [_c('button', {
    staticClass: "navbar-toggle collapsed",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#navbar",
      "aria-expanded": "false",
      "aria-controls": "navbar"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _c('span', {
    staticClass: "icon-bar"
  }), _c('span', {
    staticClass: "icon-bar"
  }), _c('span', {
    staticClass: "icon-bar"
  })]), _c('div', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/logo.svg")
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-26f7e67e!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navbar.vue
// module id = 19
// module chunks = 1